import { createRoute } from '@tanstack/react-router'
import { rootRoute } from './root'
import { ReadingTopicsPage } from '../features/reading-topics/page'

export const readingTopicsRoute = createRoute({
  path: 'reading-topics',
  getParentRoute: () => rootRoute,
  component: ReadingTopicsPage,
})
